module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page-6"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TABLE OF CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#ch01"
    }
  }, [_vm._v("I  Ambiguity and Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II  Personal Freedom and Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III The Positive Aspect of Ambiguity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Aesthetic Attitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Freedom and Liberation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Antinomies of Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Present and the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Ambiguity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0